export const TOLL_RE = /(tol(?![a-z])|toll|p[ée]age|vignet|maut)/i;
export const CORE_CATS = ["laden", "verblijf", "eten"];
export const isToll = (e) => e.category === "tol" || (!CORE_CATS.includes(e.category) && TOLL_RE.test(e.label || ""));

export const EXTRA_CATS = [
  ["overig", "Overig"],
  ["verblijf", "Verblijf"],
  ["eten", "Eten & drinken"],
  ["laden", "Laden/Vervoer"],
  ["tol", "Tol/péage"],
  ["parkeren", "Parkeren"],
  ["tickets", "Tickets"],
];
export const CAT_LABEL = Object.fromEntries(EXTRA_CATS);

export const fmtDay = (s) => s ? new Date(`${s}T12:00:00`).toLocaleDateString("nl-BE", { weekday: "short", day: "numeric", month: "short" }) : "";
export const fmtShortDate = (s) => s ? new Date(`${s}T12:00:00`).toLocaleDateString("nl-BE", { day: "numeric", month: "short" }) : "";

export const tripDates = (perDay) => {
  const ds = (perDay || []).map((d) => d.date).filter(Boolean).sort();
  return ds.length ? [ds[0], ds[ds.length - 1]] : null;
};

export const extraGroup = (e, perDay) => {
  if (e.day_number != null) return "day";
  const r = tripDates(perDay);
  if (e.date && r) {
    if (e.date < r[0]) return "vooraf";
    if (e.date > r[1]) return "achteraf";
  }
  return "trip";
};

export const outsideTotal = (extras, perDay) =>
  (extras || []).reduce((a, e) => {
    const g = extraGroup(e, perDay);
    return a + (g === "vooraf" || g === "achteraf" ? (e.amount_eur || 0) : 0);
  }, 0);

export const dateGroupHint = (dateStr, perDay) => {
  if (!dateStr) return "geen datum — telt voor de hele trip";
  const r = tripDates(perDay);
  if (!r) return "";
  if (dateStr < r[0]) return "vóór vertrek → komt bij \"Vooraf\" en wordt uitgesmeerd over de reisdagen";
  if (dateStr > r[1]) return "na de reis → komt bij \"Achteraf\" en wordt uitgesmeerd over de reisdagen";
  const d = (perDay || []).find((x) => x.date === dateStr);
  return d ? `→ dag ${d.day_number} (${fmtDay(dateStr)})` : "binnen de reisperiode";
};

const normLabel = (s) => (s || "").toLowerCase().replace(/[^a-z0-9à-ÿ]+/g, " ").trim();

const bigrams = (s) => {
  const set = new Set();
  const t = s.replace(/ /g, "");
  for (let i = 0; i < t.length - 1; i++) set.add(t.slice(i, i + 2));
  return set;
};

const labelSimilarity = (a, b) => {
  if (!a || !b) return 0;
  if (a === b) return 1;
  if (a.includes(b) || b.includes(a)) return 1;
  const ba = bigrams(a), bb = bigrams(b);
  if (!ba.size || !bb.size) return 0;
  let hits = 0;
  for (const g of ba) if (bb.has(g)) hits++;
  return (2 * hits) / (ba.size + bb.size);
};

export const findDupeGroups = (extras) => {
  const byAmt = {};
  for (const e of extras || []) {
    const k = (e.amount_eur || 0).toFixed(2);
    (byAmt[k] = byAmt[k] || []).push(e);
  }
  const groups = [];
  for (const list of Object.values(byAmt)) {
    if (list.length < 2) continue;
    const used = new Set();
    for (let i = 0; i < list.length; i++) {
      if (used.has(list[i].id)) continue;
      const grp = [list[i]];
      const a = normLabel(list[i].label);
      for (let j = i + 1; j < list.length; j++) {
        if (used.has(list[j].id)) continue;
        if (labelSimilarity(a, normLabel(list[j].label)) >= 0.7) {
          grp.push(list[j]);
          used.add(list[j].id);
        }
      }
      if (grp.length > 1) {
        used.add(list[i].id);
        groups.push(grp.sort((x, y) => (x.date || "").localeCompare(y.date || "")));
      }
    }
  }
  return groups;
};

export const dayWerkelijk = (d, extras, spread = 0) => {
  const de = extras.filter((e) => e.day_number === d.day_number);
  if (!de.length && !(spread > 0)) return null;
  const sums = { laden: 0, verblijf: 0, eten: 0 };
  let rest = 0;
  for (const e of de) {
    if (CORE_CATS.includes(e.category)) sums[e.category] += e.amount_eur || 0;
    else rest += e.amount_eur || 0;
  }
  return (sums.laden > 0 ? sums.laden : d.charging + d.overnight_charging)
    + (sums.verblijf > 0 ? sums.verblijf : d.stay)
    + (sums.eten > 0 ? sums.eten : d.food)
    + (d.tolls || 0) + rest + spread;
};
